import { TimelineEvent } from '../lib/types';

interface MicroTimelineProps {
  events: TimelineEvent[];
}

export default function MicroTimeline({ events }: MicroTimelineProps) {
  if (!events || events.length === 0) return null;

  return (
    <div className="relative pl-6" style={{ marginTop: '6px' }}>
      <div className="absolute left-[7px] top-2 bottom-2 w-[2px] bg-[#40E0D0]"></div>

      <div className="space-y-5">
        {events.map((event, index) => (
          <div key={index} className="relative">
            <div className="absolute left-[-24px] top-[2px] w-4 h-4 rounded-full bg-[#40E0D0] border-4 border-[#1A1A1A]"></div>
            <div>
              <div className="text-[14px] font-semibold text-[#F5F5F5]" style={{ marginBottom: '5px' }}>
                {event.year} —{event.title && ` ${event.title}`}
              </div>
              <div className="text-[13px] text-[#A0A0A0] leading-relaxed">
                {event.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
